import React from 'react';

import { type ActionKeys } from '@atlassian/conversation-assistant-message-actions-api/constants';
import { type ActionRendererFor } from '@atlassian/conversation-assistant-message-actions-api/types';

import { JsmLivechatActionRenderer } from './jsm-livechat-action-renderer';

type JsmLivechatActionProps = ActionRendererFor<typeof ActionKeys.JsmLivechat>;

export const JsmLivechatAction = (props: JsmLivechatActionProps): React.JSX.Element => (
	<JsmLivechatActionRenderer {...props} />
);
